import React, { useState, useCallback } from "react";
import ConstantsMap from "../../../constants/ConstantsMap";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import { ParagraphText } from "../../../styles/SharedStyles";
import "./WidgetMapLayerToggle.css";

function WidgetMapLayerToggle({ mapType, setMapType }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const makeButtonClass = useCallback(
    (type) => {
      const isActive = mapType === type;
      return `gm-basemap-option${isActive ? " active" : ""}`;
    },
    [mapType]
  );

  const handleClick = useCallback(
    (e, type) => {
      e.stopPropagation();
      const isActive = mapType === type;

      // If clicking the active option – just toggle compact/expanded
      if (isActive) {
        setIsExpanded((prev) => !prev);
        return;
      }

      // If clicking the inactive option – switch layer and collapse back to compact
      setMapType(type);
      setIsExpanded(false);
    },
    [mapType, setMapType]
  );

  return (
    <div className="leaflet-bottom leaflet-left widget-map-layer-buttons">
      <div className="leaflet-control gm-basemap">
        <div className={`gm-basemap-menu ${isExpanded ? "expanded" : "compact"}`}>
          <button type="button" className={makeButtonClass("carto")} onClick={(e) => handleClick(e, "carto")} aria-label={ConstantsTexts.CODE_238}>
            <img className="gm-basemap-thumb" alt="" src={ConstantsMap.MAP_THUMB_URL} />
            <ParagraphText className="gm-basemap-label">{ConstantsTexts.CODE_238}</ParagraphText>
          </button>
          <button type="button" className={makeButtonClass("orthophoto")} onClick={(e) => handleClick(e, "orthophoto")} aria-label={ConstantsTexts.CODE_239}>
            <img className="gm-basemap-thumb" alt="" src={ConstantsMap.ORTHO_THUMB_URL} />
            <ParagraphText className="gm-basemap-label">{ConstantsTexts.CODE_239}</ParagraphText>
          </button>
        </div>
      </div>
    </div>
  );
}

export default React.memo(WidgetMapLayerToggle);
